import { useVariant } from '@calendly/feature-check-react'
import { useEffect } from 'react'

import { useTrack, TRACKING_EVENT_NAMES } from 'hooks/analytics_events'

export const ExperimentCheckWrapper = ({ experimentName, children, onFailExperimentCheck = null }) => {
  const experimentVariant = useVariant(experimentName)
  const track = useTrack()

  useEffect(() => {
    if ((!experimentVariant || !experimentVariant.startsWith('variant')) && onFailExperimentCheck) {
      onFailExperimentCheck()
    }
  }, [experimentVariant, onFailExperimentCheck])

  useEffect(() => {
    if (experimentVariant) {
      track({
        name: TRACKING_EVENT_NAMES.FEATURE_FLAG_ENCOUNTERED,
        properties: {
          flag_key: experimentName,
          variation_key: experimentVariant,
          rule: 'ab_test',
          source: 'frontend'
        }
      })
    }
  }, [experimentVariant, experimentName, track])

  if (!experimentVariant || !experimentVariant.startsWith('variant')) {
    return null
  }

  return children
}

// To contain an A/A diagnostic test as well as the main experiment
export const DiagnosticExperimentCheckWrapper = ({ experimentName, aaExperimentName, children }) => {
  const experimentVariant = useVariant(experimentName)
  const aaExperimentVariant = useVariant(aaExperimentName)

  const track = useTrack()

  useEffect(() => {
    if (experimentVariant) {
      track({
        name: TRACKING_EVENT_NAMES.FEATURE_FLAG_ENCOUNTERED,
        properties: {
          flag_key: experimentName,
          variation_key: experimentVariant,
          rule: 'ab_test',
          source: 'frontend'
        }
      })
    }
  }, [experimentVariant, experimentName, track])

  useEffect(() => {
    if (aaExperimentVariant) {
      track({
        name: TRACKING_EVENT_NAMES.FEATURE_FLAG_ENCOUNTERED,
        properties: {
          flag_key: aaExperimentName,
          variation_key: aaExperimentVariant,
          rule: 'ab_test',
          source: 'frontend'
        }
      })
    }
  }, [aaExperimentVariant, aaExperimentName, track])

  if (!experimentVariant || !experimentVariant.startsWith('variant')) {
    return null
  }

  return children
}
